export const TEMPLATE_LIST = 'templateList';
export const USE_TEMPLATE_LIST = 'useTemplateList';
export const SURVEY_LIST = 'surveyList';
